import React from "react";
import Layout from  "../Layout/Layout.js";

const AppActive = (props) => {
  return (
    <div className="app">
      <Layout />
    </div>
  );
};


export default AppActive;